import React from 'react';
import PropTypes from 'prop-types';

// Small coloured pill for the J / P / L classification, shared by the detailed
// table and the drill-down panel.
const STYLES = {
  J: { label: 'Signed (J)',      cls: 'tw-bg-emerald-100 tw-text-emerald-700' },
  P: { label: 'Prospective (P)', cls: 'tw-bg-sky-100 tw-text-sky-700' },
  L: { label: 'Lost (L)',        cls: 'tw-bg-red-100 tw-text-red-600' },
};

const JobEntryCategoryBadge = ({ value }) => {
  const style = STYLES[value];
  if (!style) return <span className="tw-text-gray-300">—</span>;
  return (
    <span className={`tw-inline-flex tw-items-center tw-text-xs tw-font-bold tw-px-2.5 tw-py-1 tw-rounded ${style.cls}`}>
      {style.label}
    </span>
  );
};

JobEntryCategoryBadge.propTypes = { value: PropTypes.string };

export default JobEntryCategoryBadge;
